import { render, staticRenderFns } from "./pushtask.vue?vue&type=template&id=22fad109&scoped=true"
import script from "./pushtask.vue?vue&type=script&lang=js"
export * from "./pushtask.vue?vue&type=script&lang=js"
import style0 from "./pushtask.vue?vue&type=style&index=0&id=22fad109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fad109",
  null
  
)

export default component.exports